import { getImageSrc } from "csi/model/image";
import * as userModel from "csi/model/user";
import { C8Node } from "csi/typings";
import { AvatarProps } from "designSystem/components/avatar/Avatar";
import { Avatar } from "designSystem/index";
import React, { FunctionComponent } from "react";

interface UserAvatarProps extends AvatarProps {
	user: C8Node;
}

export const UserAvatar: FunctionComponent<UserAvatarProps> = (props) => {
	const { user, external, ...otherProps } = props;
	const isExternal = external || userModel.isExternal(user);
	const initials = userModel.getInitials(user);
	const imageSrc = getImageSrc(user);

	return (
		<Avatar
			external={isExternal}
			initials={initials}
			src={imageSrc}
			{...otherProps}
		/>
	);
};

export default UserAvatar;
